import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { CosmosButton, CosmosIconArrowDown } from '../../cosmos/web-scoped/react';
import { AppContext } from '../../App';

import './styled-select.scss';
import { getTrans } from '../../Utils/translate';

const StyledSelect = ({
  className,
  options,
  filterVals,
  value,
  selectFirst,
  onChange,
  onOpen,
  style = {},
  isOpen,
  dropDownClass,
  disabledOptions,
  name = 'needed',
  type = 'dropdown',
  fullWidth = false,
  maxHeight = false,
  open = false,
  description = false,
  comparison = false,
  buttonShape = 'rectangle'
}) => {
  const context = React.useContext(AppContext);
  const [visible, setVisible] = useState(false);
  const [filter, setFilter] = useState('');
  const [filterOptions, setFilterOptions] = useState(undefined);

  useEffect(() => {
    function windowClick(event) {
      if (open || visible) {
        if (typeof isOpen === 'undefined') {
          setVisible(false);
        } else if (typeof onOpen === 'function') {
          onOpen(false);
        }
      }
    }

    window.addEventListener('click', windowClick);

    return () => {
      window.removeEventListener('click', windowClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, visible]);

  const animationConfig = context.config.animation;
  const currentValue = value ? value : selectFirst ? options[0] : '';
  const lang = context.lang;

  const inputRef = useRef();

  if (!options || options.length <= 1) return <></>;

  const changeOpen = () => {
    if (typeof isOpen === 'undefined') {
      setVisible(!visible);
    } else if (typeof onOpen === 'function') {
      onOpen(!isOpen);
    }
  };

  const getLabel = (label) => {
    if (getTrans(label) !== undefined) {
      return getTrans(label);
    } else return label;
  };

  const getValue = (value) => {
    switch (value) {
      case 'All':
        return getTrans(lang.All);
      case 'top 5':
        return getTrans(lang.top5);
      case 'top 10':
        return getTrans(lang.top10);
      case 'top 15':
        return getTrans(lang.top15);
      case 'top 20':
        return getTrans(lang.top20);
      case 'Current on Track':
        return getTrans(lang.currentOnTrack);
      case 'World Cup Leader':
        return getTrans(lang.worldCupLeader);
      default:
        return value;
    }
  };

  return (
    <div
      className={`styledSelect ${type} ${options && options.length > 1 ? ' dropdown' : ''
        }${(typeof isOpen !== 'undefined' ? isOpen : visible) ? ' open' : ''}${className ? ` ${className}` : ''
        }`}>
      {type === 'dropdown' && (
        <>
          <CosmosButton
            kind="secondary"
            icon-placement="after"
            shape={buttonShape}
            onClick={() => {
              if (options && options.length > 1) changeOpen();
            }}>
            <CosmosIconArrowDown slot="icon"/>
            {description && currentValue.descriptionLabel && (
              <div className="descriptionValue">
                {getValue(currentValue.descriptionLabel)}
              </div>
            )}
            {getLabel(currentValue.selectedLabel || currentValue.label)}
          </CosmosButton>
        </>
      )}
      {type === 'input' && (
        <div className={`current`}>
          <input
            type="text"
            placeholder="Search Athlete"
            ref={inputRef}
            onClick={(e) => {
              if (options && options.length > 1) changeOpen();
            }}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </div>
      )}
      <motion.div
        className={`options${dropDownClass ? ` ${dropDownClass}` : ''}${description ? ' description' : ''
          }`}
        key="options"
        initial="closed"
        animate={(typeof isOpen !== 'undefined' ? isOpen : visible) ? 'open' : 'closed'}
        variants={{
          open: {
            opacity: 1,
            display: 'flex',
            maxHeight: inputRef.current
              ? window.innerHeight -
              (inputRef.current.getBoundingClientRect().top +
                inputRef.current.getBoundingClientRect().height +
                40)
              : maxHeight,
            paddingTop: 20,
            paddingBottom: 20
          },
          closed: {
            opacity: 0,
            maxHeight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            display: 'none'
          },
          transition: {
            duration: animationConfig.duration,
            ease: animationConfig.ease
          }
        }}>
        <PerfectScrollbar
          style={{ maxHeight: maxHeight ? maxHeight - 40 : '100vh' }}
          options={{ wheelPropagation: true }}>
          <div style={{ display: 'flex' }}>
            {filterVals && (
              <div className={`select-filterVals`}>
                <ul className={`select-filterList`}>
                  <li
                    className={`filterValue${!filterOptions ? ' active' : ''}`}
                    onClick={() => setFilterOptions(undefined)}>
                    {getTrans(lang.All)}
                  </li>
                  {Object.entries(filterVals).map(([key, values]) =>
                    values.map(({ label, value, operator }) => (
                      <li
                        key={`${key}-${getValue(value)}`}
                        className={`filterValue ${filterOptions &&
                            filterOptions.operator === operator &&
                            filterOptions.value === getValue(value) &&
                            filterOptions.field === key
                            ? ' active'
                            : 'null'
                          }`}
                        onClick={() => {
                          if (
                            filterOptions &&
                            filterOptions.operator === operator &&
                            filterOptions.value === getValue(value) &&
                            filterOptions.field === key
                          ) {
                            setFilterOptions(undefined);
                          } else {
                            setFilterOptions({
                              operator: operator,
                              value: getValue(value),
                              field: key
                            });
                          }
                        }}>
                        {getValue(label)}
                      </li>
                    ))
                  )}
                </ul>
              </div>
            )}
            <div className="options-inner">
              {Array.isArray(options) &&
                options
                  .filter(
                    ({ searchLabel }) =>
                      !filter || searchLabel.toLowerCase().includes(filter.toLowerCase())
                  )
                  .filter((entry) => {
                    if (!filterOptions) return true;
                    switch (filterOptions.operator) {
                      case 'lt':
                        return (
                          entry &&
                          entry[filterOptions.field] &&
                          parseInt(entry[filterOptions.field]) <= filterOptions.value
                        );
                      case 'gt':
                        return (
                          entry &&
                          entry[filterOptions.field] &&
                          parseInt(entry[filterOptions.field]) >= filterOptions.value
                        );
                      case 'eq':
                        return (
                          entry &&
                          entry[filterOptions.field] &&
                          //eslint-disable-next-line
                          entry[filterOptions.field] == filterOptions.value
                        );
                      default:
                        return true;
                    }
                  })
                  .map((data) => {
                    return (
                      <div
                        key={`select-${name}-${data.value}`}
                        className={`option${data.value === currentValue.value ? ' active' : ''
                          }${disabledOptions &&
                            disabledOptions.includes(data.value) &&
                            data.value !== currentValue.value
                            ? ' disabled'
                            : ''
                          }`}
                        onClick={() => {
                          if (
                            (disabledOptions && !disabledOptions.includes(data.value)) ||
                            (!disabledOptions && data.value !== currentValue.value)
                          ) {
                            if (typeof onChange === 'function') onChange(data);
                            changeOpen();
                          }
                        }}>
                        {data.label.props !== undefined &&
                          typeof data.label.props.children === 'string'
                          ? getValue(data.label.props.children)
                          : data.label}
                      </div>
                    );
                  })}
            </div>
          </div>
        </PerfectScrollbar>
      </motion.div>
    </div>
  );
};

export { StyledSelect };
